// Store module for managing user settings
export default {
  namespaced: true,

  state: {
    breadcrumb: {
      enabled: true,
      maxItems: 5
    }
  },

  getters: {
    breadcrumbSettings: state => state.breadcrumb,
    isBreadcrumbEnabled: state => state.breadcrumb.enabled,
    breadcrumbMaxItems: state => state.breadcrumb.maxItems
  },

  mutations: {
    SET_BREADCRUMB_ENABLED(state, enabled) {
      state.breadcrumb.enabled = enabled;
      // Save to sessionStorage
      sessionStorage.setItem("userSettings", JSON.stringify(state));
    },

    SET_BREADCRUMB_MAX_ITEMS(state, maxItems) {
      state.breadcrumb.maxItems = maxItems;
      // Save to sessionStorage
      sessionStorage.setItem("userSettings", JSON.stringify(state));
    },

    LOAD_SETTINGS_FROM_SESSION(state) {
      const savedSettings = sessionStorage.getItem("userSettings");
      if (savedSettings) {
        try {
          const parsed = JSON.parse(savedSettings);
          if (parsed.breadcrumb) {
            state.breadcrumb = {
              ...state.breadcrumb,
              ...parsed.breadcrumb
            };
          }
        } catch (error) {
          console.warn("Failed to load user settings from session:", error);
        }
      }
    }
  },

  actions: {
    setBreadcrumbEnabled({ commit }, enabled) {
      commit("SET_BREADCRUMB_ENABLED", enabled);
    },

    setBreadcrumbMaxItems({ commit }, maxItems) {
      commit("SET_BREADCRUMB_MAX_ITEMS", maxItems);
    },

    loadSettingsFromSession({ commit }) {
      commit("LOAD_SETTINGS_FROM_SESSION");
    }
  }
};
